import { getFirstUrl } from './login';

export const transferIdParams = {
    operate_source: 'web',
    first_url: getFirstUrl(),
    channel: window.sessionStorage.getItem('channel'),
};
